module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/security/role/role.component.scss
// module id = ./src/app/components/security/role/role.component.scss
// module chunks = main